import { Form, Input, message, Modal } from "antd"
import { t } from "i18next"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router"
import { Paths } from "~/constants"
import { TemplateData } from "../../../types/types"
import { fetchTemplateId, updateTemplate } from "../service/blockContent"

const ModalEditTemplate: React.FC = () => {
  const [form] = Form.useForm()
  const [dataInit, setDataInit] = useState<TemplateData | null>(null)
  const navigate = useNavigate()
  const { id } = useParams()

  const fetchTemplateData = async () => {
    const response = (await fetchTemplateId(Number(id))) as TemplateData
    setDataInit(response)
    form.setFieldsValue({
      templateName: response?.attributes?.templateName,
      isTemplate: response?.attributes?.isTemplate,
    })
  }

  useEffect(() => {
    fetchTemplateData()
  }, [id])

  const handleEditTemplate = async () => {
    try {
      const values = await form.validateFields()
      const { templateName } = values
      const data = {
        data: {
          templateName,
          isTemplate: true,
        },
      }
      await updateTemplate(Number(id), data)
      navigate(`${Paths.BLOCK_CONTENT.LIST.PATH}`)
      form.resetFields()
      message.success("Template đã được cập nhật thành công!")
    } catch (error) {
      message.error("Không thể cập nhật template. Vui lòng thử lại.")
    }
  }

  return (
    <Modal
      title={t("Sửa thông tin template")}
      open={true}
      onCancel={() => {
        form.resetFields()
        navigate(`${Paths.BLOCK_CONTENT.LIST.PATH}`)
      }}
      onOk={handleEditTemplate}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          templateName: dataInit?.attributes?.templateName,
          isTemplate: dataInit?.attributes?.isTemplate,
        }}
      >
        <Form.Item
          label={t("Tên template")}
          name="templateName"
          rules={[{ required: true, message: t("Vui lòng nhập tên template") }]}
        >
          <Input placeholder={t("Tên template")} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ModalEditTemplate
